import { gspx } from '@rsos/capstone';

const DATA_MAP_CATEGORY = 'Data Map';
const SPATIAL_LAYER_CATEGORY = 'Spatial Layer';

// The tracking in this file are all CRG map card specific. Newer spatial layers
// tracking should be added to useDeckGL/spatialTracking.js
export const trackDisclaimerClick = (
  irpVersion,
  showDisclaimerState,
  source,
) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    irpVersion,
    name: `Click to ${
      showDisclaimerState ? 'close' : 'open'
    } ${source} disclaimer`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
  });
};

export const trackHoverOnPin = irpVersion => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    irpVersion,
    name: 'Hover on a pin in CRG map card',
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
  });
};

export const trackHoverOnPinWithTime = (
  time,
  isConnectedCar = false,
  irpVersion,
) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    irpVersion,
    name: `Hover more than ${time} second for a call in CRG map card`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
  });
};

/**
 * Track clicks on up/down arrow
 * @param {String} arrowDirection - `up` or `down`
 * @param {String} irpVersion - IRP Version
 * @param {String} source - source of spatial layer
 */
export const trackClickOnFloorArrow = (arrowDirection, irpVersion, source) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    name: `${source} toggle floor ${arrowDirection} button`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
    irpVersion,
  });
};

export const trackClickLinkOutButton = (irpVersion, source) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    name: `${source} view PDF`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
    irpVersion,
  });
};

export const trackClickOnSpatialObject = (irpVersion, externalId, source) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    name: `Click on ${source} spatial object ${externalId}`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
    irpVersion,
  });
};

export const trackFloorSelector = (irpVersion, source) => {
  gspx.trackCustomEvent(DATA_MAP_CATEGORY, {
    name: `${source} select option from floor plan drop-down menu`,
    Category: SPATIAL_LAYER_CATEGORY,
    'Launched date': new Date(),
    irpVersion,
  });
};
